export default function Proof() {
  return (
    <section
      data-testid="testimonials-section"
      className="py-12 px-6 max-w-6xl mx-auto border-t border-white/10 text-center"
    >
      <p className="font-mono-lbl text-xs uppercase text-slate-500 tracking-widest">
        Client Testimonials
      </p>
      <div className="mt-4 p-8 border border-dashed border-white/15 rounded-xl max-w-xl mx-auto bg-white/[0.02]">
        <p className="text-sm text-slate-400">
          Verified driver reviews and repair ratings from the Dayton &amp; Cincinnati area will appear here.
        </p>
      </div>
    </section>
  );
}
